module.exports = __webpack_public_path__ + "static/img/89-3.489a463.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/89-3.jpg
// module id = 4qih
// module chunks = 0